export default function RenterPersonalField({ label, value }) {
  return (
    <div className="h-20">
      <label className="font-semibold text-sm">{label}:</label>
      <p className="border border-gray h-[43px] text-gray2 p-2 overflow-hidden rounded w-full bg-[#ffffff]">{value}</p>
    </div>
  )
}

